import { useContext } from 'react';
import { UniversityContext } from './UniversityContext';

export const useUniversityContext = () => useContext(UniversityContext);
